<div class="flex flex-col my-auto rounded-full">
  <div class="flex sm:flex-row flex-col sm:mx-auto justify-center">
    <!-- Select img CTA button -->
    <!-- mobile -->
    <div class="block md:hidden">
      <label *ngIf="!imageUrl && status === statusEn.init" class="btn-primary block text-center w-full my-8">
        <span>{{ "modules.evcQuote.general.selectPicture.mobileTake" | translate }}</span>
        <input type="file" capture accept="image/*" (change)="sendImage($event)" data-cy="image-input" />
      </label>

      <label *ngIf="!imageUrl && status === statusEn.init" class="btn-secondary block text-center w-full my-8">
        <span>{{ "modules.evcQuote.general.selectPicture.mobile" | translate }}</span>
        <input type="file" accept=".png, .jpg, .jpeg" (change)="sendImage($event)" data-cy="image-input" />
      </label>
    </div>

    <!-- desktop -->
    <div class="hidden md:flex">
      <label *ngIf="!imageUrl && status === statusEn.init">
        <div class="btn-add-new">
          <img
            class="bg-grey-light box-shadow-small rounded-full mb-8"
            src="assets/evc/img/plus.svg"
            [alt]="'modules.evcQuote.general.selectPicture.desktop' | translate"
          />
          <span class="text-primary font-sans font-bold">{{
            "modules.evcQuote.general.selectPicture.desktop" | translate
          }}</span>
          <span class="pt-12 text-base text-grey-dark60">{{
            "modules.evcQuote.general.selectPicture.description" | translate
          }}</span>
        </div>

        <input type="file" capture accept=".png, .jpg, .jpeg" (change)="sendImage($event)" data-cy="image-input" />
      </label>
    </div>

    <!-- Selected image -->
    <div *ngIf="imageUrl || status === statusEn.loading" class="img-preview-container">
      <div class="img-preview{{ status === statusEn.failed ? '-error' : '' }}">
        <img *ngIf="imageUrl || status !== statusEn.loading" [src]="imageUrl" alt="" data-cy="image-displayed" />
        <!-- Loading -->
        <div *ngIf="status === statusEn.loading && !imageUrl" class="img-loading-overlay">
          <div class="img-spinning-circle"></div>
        </div>
      </div>
    </div>
  </div>
</div>
